import { ROLE_COLOR_MAP } from 'components/IAP/ICSConstants';

const getColor = (role: string) => {
  return ROLE_COLOR_MAP[role] || 'lightgray';
};

const RoleTag: React.FC<{ icsRoles: string | string[] }> = ({ icsRoles }) => {
  const rolesArray = Array.isArray(icsRoles)
    ? icsRoles
    : icsRoles.includes(',')
      ? icsRoles.split(',').map((role) => role.trim())
      : [icsRoles];

  return (
    <div className={'d-flex flex-wrap gap-2'}>
      {rolesArray.map((role, index) => (
        <div
          key={index}
          className={`planning-task-list-head ${getColor(role)}`}
        >
          {role}
        </div>
      ))}
    </div>
  );
};

export default RoleTag;
